import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import TypographyWithI18N from 'shared/components/TypographyWithI18N';
import styles from './LabelValuePair.module.scss';

export interface ILabelValuePairProps {
  id: string;
  label: string;
  value: string | undefined;
  labelSx?: any;
  valueSx?: any;
}

const LabelValuePair: React.FC<ILabelValuePairProps> = ({
  id,
  label,
  value,
  labelSx,
  valueSx,
  ...props
}) => {
  return (
    <Box
      className={styles.labelValuePairContainer}
      id={`${id}-wrapper`}
      data-testid={`${id}-wrapper`}
      sx={{
        flexWrap: 'nowrap',
        WebkitFlexWrap: 'nowrap',
      }}
      {...props}
    >
      <TypographyWithI18N
        className='kfic2-bodyText'
        id={`${id}-label`}
        data-testid={`${id}-label`}
        i18nKey={label}
        textSuffix={':'}
        sx={{
          mr: 1,
          ...labelSx,
        }}
      />
      <Typography
        className='kfic2-bodyTextBold'
        sx={{
          ...valueSx,
          '&:focus': { width: 'fit-content' },
          textOverflow: 'initial',
          wordBreak: 'break-word',
          overflow: 'auto',
          whiteSpace: 'normal',
          display: 'flex',
          width: 'auto',
          minWidth: '60px',
          margin: ' 0 8px 0px 0',
        }}
      >
        <span
          aria-label={value}
          title={value}
          id={id}
          data-testid={id}
          className={styles.value}
        >
          {value}
        </span>
      </Typography>
    </Box>
  );
};

export default LabelValuePair;
